import React, { useState } from 'react';

import Box from '@mui/material/Box';
import { CustomCarousel } from '../CustomCarousel';
import { FlipCardItem } from '../../../models/LessonComponentContent';
import { FlipCardProps } from './FlipCard';
import { FlipEach } from './FlipEach';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../../services/LessonComponentService';
import componentStyles from '../../../styles/LessonComponents.module.css';
import styles from '../../../styles/FlipCard.module.scss';
import useThemes from '../../../../shared/hooks/useThemes';

export const FlipCardView = (props: FlipCardProps) => {
  const flipCards: FlipCardItem[] = props.component?.content.flipCard;
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  /** Set number of items display in the viewport */
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 570, itemsToShow: 3 }
  ];

  return (
    <Grid container direction="column" style={{ fontFamily }}>
      <Grid className={`${styles.instructionText}`}>
        <Box className={componentStyles.textOverflow}>
          <span
            className="ql-editor"
            dangerouslySetInnerHTML={{
              __html: LessonComponentService.getUrlWithSas(
                props.component?.content.caption
              )
            }} //value has been sanitized before storing into db.
          ></span>
        </Box>
      </Grid>
      <Grid>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            className={`${styles.carouselContainer} ${
              flipCards?.length < 3
                ? 'rec-item-wrapper rec-slider'
                : 'rec-slider-position'
            }`}
          >
            <CustomCarousel
              breakPoints={breakPoints}
              currentItemIndex={currentItemIndex}
              setCurrentItemIndex={setCurrentItemIndex}
              items={flipCards?.map((flipCard) => (
                <div
                  key={flipCard.id}
                  className={styles.carouselItemsContainer}
                >
                  <FlipEach
                    flipCard={flipCard}
                    response={props.component.answer}
                    onSubmit={props.onSubmit}
                  />
                </div>
              ))}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
